var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionsOnboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3F7CDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.414 14.9866C17.289 14.8616 17.1194 14.7914 16.9427 14.7914C16.7659 14.7914 16.5963 14.8616 16.4713 14.9866L16 15.4572C15.877 15.5846 15.7299 15.6862 15.5672 15.756C15.4045 15.8259 15.2296 15.8627 15.0525 15.8642C14.8755 15.8658 14.6999 15.832 14.5361 15.765C14.3722 15.698 14.2233 15.599 14.0981 15.4738C13.9729 15.3486 13.8739 15.1997 13.8069 15.0359C13.7399 14.872 13.7061 14.6964 13.7077 14.5194C13.7092 14.3423 13.746 14.1674 13.8159 14.0047C13.8857 13.842 13.9873 13.6949 14.1147 13.5719L17.868 9.81724C18.7566 9.61513 19.6863 9.69831 20.525 10.055C21.3636 10.4116 22.0684 11.0236 22.5392 11.8038C23.0101 12.5841 23.2229 13.4929 23.1475 14.4011C23.0722 15.3093 22.7124 16.1706 22.1193 16.8626L20.714 18.2859L17.414 14.9859V14.9866ZM10.1073 10.9786C10.7972 10.2888 11.6995 9.8519 12.6684 9.73842C13.6373 9.62495 14.6161 9.84156 15.4467 10.3532L13.1713 12.6292C12.6785 13.1211 12.3976 13.7861 12.3886 14.4823C12.3796 15.1785 12.6433 15.8505 13.1232 16.3549C13.6031 16.8593 14.2613 17.156 14.957 17.1816C15.6528 17.2072 16.331 16.9597 16.8467 16.4919L16.9427 16.4006L19.7713 19.2286L16.9427 22.0572C16.6926 22.3072 16.3535 22.4476 16 22.4476C15.6464 22.4476 15.3074 22.3072 15.0573 22.0572L10.1067 17.1066C9.29408 16.2939 8.83759 15.1918 8.83759 14.0426C8.83759 12.8934 9.29408 11.7912 10.1067 10.9786H10.1073Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsOnboard);
export default __webpack_public_path__ + "static/media/actions-onboard.b42a3c5769e0a44466ed489f645f0730.svg";
export { ForwardRef as ReactComponent };